export default {
    /*
    appName: null,
    appDesc: null,
    appAbi: null,
    appNetwork: null,
    appAddress: null,
    */
    appData: {},
};